
import { LinksGroupWire } from 'app/area/links-section/types';
import { RemoteData } from 'app/infrastructure/remote-data';
import { ApiResponse } from 'app/types-shared';

export const endpoint = {
  externalUrlGroup: 'externalUrl/group'
};

export const api = {

  /**
   * Loads configurable links.
   */
  loadLinks: async (): Promise<LinksGroupWire[]> => {
    const request = await new RemoteData(endpoint.externalUrlGroup)
      .resource<ApiResponse<LinksGroupWire[]>>()
      .single();

    return request.data;
  }
};
